// 致命技を弾いた瞬間の、ボスののけぞり (10-20 作者・記録 docs/research/2026-10-20-exec-parry-recoil-in-slow.md・台帳 docs/ledger/combat.md)。
//   作者「弾いた瞬間にのけぞってないといけない…スローの時に弾いてる絵が出てないと、スローが終わった後に弾いた絵が出てるような感じで、なんか変な感じする」。
//   new (配布版) = 弾いたコマ (止めの最初のコマ) から弾かれの絵・のけぞりを出す。
//     騎士・花嫁 = 固有の弾かれの絵へすぐ替える (src/exec_unique.ts。前は当たりの 12% = スローの途中まで振りの絵のまま)。
//     ほかのボス = 弾かれの絵があればそれへ替え、無ければ当たりの絵のまま後ろへ反らす (execParriedTimeline)。
//       前は致命の絵の並びがそのまま進み、スローの間ずっと噛み・斬りの絵だった (揺れ 20px だけ)。
//   old = 前の版 (DEV ?execParryRecoil=old・game.ts)。
//   10-21 (作者が答えるページで選んだ・台帳 docs/ledger/combat.md): 介錯 B・覚醒王 A・剣舞 B の弾かれの絵 (exec_parried_1021)。
//     前は3体とも当たりの絵を反らすだけだった = DEV ?execParriedArt=old。介錯は砲を持っている時だけ絵が無いので反らす。
import type { BossAttackTimeline } from './boss_pose_timeline'
import { findContactKey } from './boss_pose_timeline'

export type ExecParryRecoil = 'new' | 'old'
let version: ExecParryRecoil = 'new'
export function setExecParryRecoil(value: string | null | undefined): ExecParryRecoil {
  version = value === 'old' ? 'old' : 'new'
  return version
}
export function execParryRecoilNow(): boolean { return version === 'new' }

/** 致命を弾かれた時だけの絵 (10-21・普段のパリィの 'parried' とは別のキー)。 */
export const EXEC_PARRIED_ART_1021 = 'exec_parried_1021'
/** 10-21 の絵を持つボス。介錯は刃の時だけ (public/sprites/bosses/the-executioner/blade/)。 */
export const EXEC_PARRIED_ART_1021_BOSSES: readonly string[] = ['the-executioner', 'crowned-king-awoken', 'blade-dancer']
/** 弾かれの絵を持つボス → 絵のキー (public/sprites/bosses/<id>/parried.png は普段のパリィでは替えない絵)。騎士・花嫁は固有の致命を切った時 (DEV ?execUnique=0) だけここを通る。 */
const PARRIED_ART: Record<string, string> = {
  'dream-hound': 'parried', 'inverted-jester': 'parried', 'former-princess': 'parried', 'vigil-knight': 'parried', 'bride': 'parried',
  ...Object.fromEntries(EXEC_PARRIED_ART_1021_BOSSES.map((id) => [id, EXEC_PARRIED_ART_1021])),
}

export type ExecParriedArt = 'new' | 'old'
let artVersion: ExecParriedArt = 'new'
/** DEV ?execParriedArt=old = 10-21 の3枚を使わない前の版 (当たりの絵を反らす)。 */
export function setExecParriedArt(value: string | null | undefined): ExecParriedArt {
  artVersion = value === 'old' ? 'old' : 'new'
  return artVersion
}
export function execParriedArtNew(): boolean { return artVersion === 'new' }
/** 10-31 覚醒獣の弾かれの絵の描き直し (作者 10-30「元のものとだいぶ違う」・記録 docs/research/2026-10-31-awoken-exec-parried-redraw-2.md)。
 *  元の絵 (10-21 より前に出ていた宙で首を伸ばす絵 bite_contact_up_0910) だけをお手本に描いた3案。前の2案 a|b は作者が没にした (_archived-2026-10-31-parried-ab/)。
 *  配布版 = d 起き上がる (10-31 作者が答えるページ 3bZN9M3q で選んだ)。?awokenParried=c|e で他の案、=now で 10-21 の絵。
 *  c = 低く浮く / d = 起き上がる / e = 四つ足で踏ん張り頭だけ跳ね上がる。 */
export const AWOKEN_PARRIED_1031 = { c: 'exec_parried_1031c', d: 'exec_parried_1031d', e: 'exec_parried_1031e' } as const
export type AwokenParriedVariant = keyof typeof AWOKEN_PARRIED_1031
let awokenParried: AwokenParriedVariant | null = 'd'
export function setAwokenParriedArt(value: string | null | undefined): AwokenParriedVariant | null {
  awokenParried = value === 'now' ? null : value && value in AWOKEN_PARRIED_1031 ? value as AwokenParriedVariant : 'd'
  return awokenParried
}
/** 覚醒獣の弾かれの絵のキー (=now の時だけ null = 10-21 の絵)。 */
export function awokenParriedArtKey(): string | null { return awokenParried ? AWOKEN_PARRIED_1031[awokenParried] : null }
function parriedArtOf(bossId: string): string | undefined {
  const key = PARRIED_ART[bossId]
  if (key === EXEC_PARRIED_ART_1021 && artVersion === 'old') return undefined
  if (bossId === 'crowned-king-awoken' && awokenParried) return AWOKEN_PARRIED_1031[awokenParried]
  return key
}
/** 弾かれの絵が無いボスの、後ろへ反らす角度 (deg・負 = 後ろへ・足元を軸に)。 */
export const EXEC_PARRIED_LEAN_DEG = -7
/** 弾かれの絵 (または反った姿) を保つ所 = 戻りの割合。ここで待機へ戻す。 */
export const EXEC_PARRIED_IDLE_AT = 0.6

const byAuthored = new WeakMap<BossAttackTimeline, Map<string, BossAttackTimeline>>()
const noAuthored = new Map<string, BossAttackTimeline>()

/** 騎士・花嫁以外のボスが致命技を弾かれた後の絵の並び。当たり (active) の頭から弾かれの姿で、戻りの途中で待機へ。
 *  authored = そのボスの致命の並び (覚醒王は噛み固めの段取りを当てた後の並び)。絵の並びが無いボス (剣舞・虚ろの役者) は undefined。 */
//   noArt = 弾かれの絵を使わず反らす (介錯が砲を持っている時)。
export function execParriedTimeline(bossId: string, authored: BossAttackTimeline | undefined, noArt = false): BossAttackTimeline {
  let cache = noAuthored
  if (authored) {
    cache = byAuthored.get(authored) ?? new Map()
    byAuthored.set(authored, cache)
  }
  const artKey = noArt ? undefined : parriedArtOf(bossId)
  const cacheKey = `${bossId}|${artKey ?? ''}`
  const hit = cache.get(cacheKey)
  if (hit) return hit
  const art = artKey !== undefined
  const image = artKey ?? (authored ? findContactKey(authored, undefined)?.image : undefined) ?? 'active'
  const lean = art ? 0 : EXEC_PARRIED_LEAN_DEG
  const out: BossAttackTimeline = [
    // 止めの最初のコマから反り切った姿 (止めの間は動かない = 弾いた瞬間の姿がそのまま見える)。スローの間に少しだけ戻る。
    { phase: 'active', at: 0.0, image, tag: 'contact', hold: true, ease: 'linear', rot: lean },
    { phase: 'active', at: 0.999, image, hold: true, ease: 'step', rot: lean * 0.8 },
    { phase: 'recovery', at: 0.0, image, hold: true, ease: 'easeInOut', rot: lean * 0.8 },
    { phase: 'recovery', at: EXEC_PARRIED_IDLE_AT - 0.001, image, hold: true, ease: 'step', rot: 0 },
    { phase: 'recovery', at: EXEC_PARRIED_IDLE_AT, image: 'idle', hold: true, rot: 0 },
  ]
  cache.set(cacheKey, out)
  return out
}
